<script setup lang="ts">
interface IncludedGroup {
  title: string;
  items: string[];
}

interface IncludedBlock {
  header: string;
  intro?: string;
  groups: IncludedGroup[];
}

defineProps<{
  block: IncludedBlock;
}>();
</script>

<template>
  <section class="bg-white dark:bg-slate-900">
    <div class="mx-auto w-full max-w-6xl px-4 py-10 md:py-16">
      <header class="mb-10 flex flex-col gap-4 md:mb-14">
        <h2
          class="font-display italic text-3xl text-slate-900 md:text-4xl dark:text-white"
        >
          {{ block.header }}
        </h2>
        <div class="h-1 w-16 rounded-full bg-amber-400" />
        <p
          v-if="block.intro"
          class="max-w-3xl font-body text-base leading-relaxed text-slate-600 md:text-lg dark:text-slate-300"
        >
          {{ block.intro }}
        </p>
      </header>

      <div class="grid gap-8 md:grid-cols-2 md:gap-12">
        <div
          v-for="(group, gi) in block.groups"
          :key="gi"
          class="rounded-2xl border border-slate-200 bg-slate-50/60 p-6 md:p-8 dark:border-slate-700 dark:bg-slate-800/30"
        >
          <h3
            class="font-body text-xs uppercase tracking-[0.22em] text-amber-600 dark:text-amber-400"
          >
            {{ group.title }}
          </h3>
          <ul class="mt-5 space-y-3">
            <li
              v-for="(item, i) in group.items"
              :key="i"
              class="flex items-start gap-3 text-slate-800 dark:text-slate-200"
            >
              <svg
                class="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-500"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M5 12l5 5 9-11" />
              </svg>
              <span class="font-body text-base leading-relaxed md:text-lg">
                {{ item }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
